<template>
  <section>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper p-0">
        <router-view :key="project.id" :project="project"></router-view>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['id'],
  data () {
    return {
      project: {
        id: null,
        short_name: null,
        short_description: null
      },
    }
  },
  methods: {
    loadProject(){
      axios.get('/api/project/'+this.id).then(({ data }) => {
        this.project = data;
      });
    },
  },
  watch: {
    $route(to, from) {
      if(this.$route.name.split(".")[0] == 'project' && from.params.id){
        if(from.params.id != this.id){
          this.loadProject();
        }
      }
    }
  },
  created() {
    this.$Progress.start();
    this.loadProject();
    this.$Progress.finish();
  }
}
</script>
